<template>
  <modal :show="showModal" modal-classes="modal-secondary" size="lg">
    <div class="text-center mb-5">
      <h2>{{ $t("SALES_ORDERS.ADD_DELIVERY") }}</h2>
    </div>
    <form class="" @submit.prevent="">
      <div
        class="row delivery-item"
        v-for="item in salesOrder.deliveryItemsState.remainingItems"
        :key="item.id"
      >
        <div class="col-6 delivery-item-name">
          <span class="code text-bold h3">{{ item.code }}</span>
          <span class="name">{{ item.name }}</span>
          <div class="except text-muted" v-html="item.excerpt"></div>
        </div>
        <div class="col-3">
          <base-input
            :label="`${$t('COMMON.QUANTITY')} (*)`"
            :placeholder="$t('COMMON.QUANTITY')"
            v-model="deliveryItemsModel[item.id].quantity"
            type="number"
            step="1"
            input-classes="form-control-alternative"
          >
          </base-input>
          <validation-error :errors="apiValidationErrors.quantity" />
        </div>
        <div class="col-3 row">
          <span class="col-12 text-bold h3">{{
            $t("COMMON.UNIT_OF_MEASURE_UNIT")
          }}</span>
          <object-link
            class="col-12"
            :object="deliveryItemsModel[item.id].unitOfMeasureUnit"
          />
        </div>
      </div>
    </form>

    <template slot="footer">
      <button
        type="submit"
        class="btn btn-primary"
        @click="handleSubmit"
        :disabled="loading"
      >
        <span v-if="loading" class="btn-inner--icon">
          <i class="fas fa-spinner fa-spin"></i>
        </span>
        {{ $t("SALES_ORDERS.ADD_DELIVERY") }}
      </button>

      <button
        type="button"
        class="btn btn-link ml-auto"
        @click="closeSalesOrderDeliveryForm"
        :disabled="loading"
      >
        {{ $t("COMMON.CLOSE") }}
      </button>
    </template>
  </modal>
</template>

<script>
import {
  DropdownMenu,
  DropdownItem,
  Dropdown,
  Tooltip,
  Select,
  Option,
  Button,
} from "element-ui";
import { cloneDeep } from "lodash";
import formMixin from "@/mixins/form-mixin";
import requestErrorMixin from "@/mixins/request-error-mixin";
import ValidationError from "@/components/ValidationError.vue";

export default {
  name: "sales-order-view-details-sales-order-item-form",

  components: {
    ValidationError,
    [Tooltip.name]: Tooltip,
    [Dropdown.name]: Dropdown,
    [DropdownItem.name]: DropdownItem,
    [DropdownMenu.name]: DropdownMenu,
    [Select.name]: Select,
    [Option.name]: Option,
    [Button.name]: Button,
  },

  mixins: [formMixin, requestErrorMixin],

  props: ["salesOrder", "showModal"],

  data() {
    this.setDeliveryItemsModel();
    return {
      deliveryItemsModel: [],
      loading: false,
    };
  },

  computed: {},

  methods: {
    setDeliveryItemsModel() {
      if (this.salesOrder.deliveryItemsState.remainingItems) {
        const deliveryItemsData = {};
        for (const item of Object.values(
          this.salesOrder.deliveryItemsState.remainingItems
        )) {
          deliveryItemsData[item.id] = {
            id: item.id,
            quantity: item.quantity,
            unitOfMeasureUnit: item.unitOfMeasureUnit,
          };
        }
        this.deliveryItemsModel = deliveryItemsData;
      }
    },

    closeSalesOrderDeliveryForm() {
      this.$emit("closeSalesOrderDeliveryForm", true);
    },

    async handleSubmit() {
      this.loading = true;
      const deliveryItemsModelData = cloneDeep(this.deliveryItemsModel);
      try {
        const delivery = await this.$store.dispatch(
          "salesOrders/generateDelivery",
          {
            id: this.salesOrder.id,
            items: deliveryItemsModelData,
          }
        );
        this.$notify({
          type: "success",
          message: this.$t("SALES_ORDERS.SALES_ORDER_DELIVERY_ADDED"),
        });
        this.$router.push(this.$objectViewRoute(delivery));
        this.loading = false;
      } catch (error) {
        this.$notify({
          type: "danger",
          message: this.$t("ERRORS.SOMETHING_WENT_WRONG"),
        });
        await this.showRequestError(error);
        this.formErrors = error.response.data.errors;
        this.loading = false;
      }
    },
  },

  mounted() {},

  watch: {
    showModal() {
      this.setDeliveryItemsModel();
    },
    salesOrder() {
      this.setDeliveryItemsModel();
    },
  },
};
</script>
<style scoped>
.delivery-item .delivery-item-name {
  display: flex;
  flex-direction: column;
  justify-content: center;
}
</style>
